import { makeStyles, shorthands } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme/M365PulseTheme.types";

export const useStyles = makeStyles({
    userMenu: {
        ...shorthands.margin("5px")
    },
    popover: {
        width: "400px"
    },
    personaItem: {
        ...shorthands.margin("10px", 0),
        height: "100px",
        ":hover": {
            cursor: "default"
        }
    },
    cachedItem: {
        ...shorthands.margin("10px", 0),
        height: "50px",
        display: "flex"
    },
    cachedPersonal: {
        float: "left",
        width: "220px",
        ...shorthands.overflow("hidden"),
        textOverflow: "ellipsis"
    },
    cachedButton: {
        position: "absolute",
        top: "15px",
        right: "12px"
    },
    textMessage: {
        ...shorthands.overflow("hidden"),
        width: "200px",
        textOverflow: "ellipsis",
        lineHeight: "20px"
    },
    link: {
        textDecorationLine: "underline",
        color: themeTokens.colorNeutralForeground2,
        fontSize: "13px",
        lineHeight: "20px",
        ":hover": {
            color: themeTokens.colorNeutralForeground2
        }
    },
    name: {
        marginBottom: "5px"
    }
});
